import React, { useState } from "react";
import CheckIcon from "../../../../assets/images/Icon/check-icon.svg";
import step1Image from "../../../../assets/images/aide-a-domicile.svg";
import Layout from "../../../Layout";
import { StyledContainer } from "../../../Layout/styled";
import Stepper from "../../../Steps";
import {
  Box,
  Step1Img,
  StyledSvg,
  StyledTextZone,
  Text,
  TextSection,
  TitleH1,
} from "./styled";

const LeadFormPage = () => {
  const [data, setData] = useState({
    categorie: [],
    frequency: "",
    recipient: "",
    name: "",
    phone: "",
    email: "",
    statut: "",
  });

  return (
    <Layout>
      {/*  */}
      <StyledContainer>
        <Box>
          <TitleH1>TROUVEZ UNE AIDE À DOMICILE PRES DE CHEZ VOUS</TitleH1>
          <Step1Img alt="set1" src={step1Image} />
        </Box>

        <Stepper data={data} setData={setData} />
      </StyledContainer>
      {/*  */}
      <TextSection>
        <StyledContainer>
          <StyledTextZone>
            <Text>
              <StyledSvg src={CheckIcon} alt="check icon" />
              GRATUIT ET SANS ENGAGEMENT
            </Text>
            <Text>
              <StyledSvg src={CheckIcon} alt="check icon" />
              ACCOMPAGNEMENT 7J/7, 24H/24
            </Text>
            <Text>
              <StyledSvg src={CheckIcon} alt="check icon" />
              DES INTERVENANTS PRES DE CHEZ VOUS
            </Text>
          </StyledTextZone>
        </StyledContainer>
      </TextSection>
    </Layout>
  );
};

export default LeadFormPage;
